export interface LetterRequestCustomer_ScheduleTable_Co_Interface {
  letterId: number,
  code:string,
  customerId:number,
  customerName:string,
  expert:Array<string>,
  file:Array<string>,
  expert_Visible:boolean,
  customerNameFull:string,
  del:boolean,
  status:number,
  deviceCount:number,
  expertChange:number,
  deviceChange:number,
  letterChange:number,
}
export function Empty_LetterRequestCustomer_ScheduleTable_Co_Interface():LetterRequestCustomer_ScheduleTable_Co_Interface{
  return{
    letterId: 0,
    code:'',
    customerId:0,
    customerName: '',
    expert:[],
    file:[],
    customerNameFull:'',
    del:false,
    expert_Visible:false,
    status:0,
    deviceCount:0,
    letterChange:0,
    deviceChange:0,
    expertChange:0,
  }
}
